import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Shared axios instance — credentials so the session_token cookie flows.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
